import { Svg } from '../Svg';
import { useGlobalContext } from '../../contexts';

export function Modal() {
  const {
    state: { modal },
    actions: { closeModal },
  } = useGlobalContext();

  const { className, ...props } = { ...modal.props };

  return modal.children ? (
    <div
      className={`global-site-modal fixed top-1/2 left-1/2 z-50 max-h-[calc(var(--viewport-height)-2rem)]  max-w-[1200px] -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-[10px] bg-white bg-gradient-to-r from-[#F1DCC126] to-[#2179C24A] max-md:max-w-full ${className}`}
      {...props}
    >
      <button
        aria-label="Close modal"
        className="absolute right-6 top-6  z-10 flex h-7 w-7 items-center justify-center"
        onClick={closeModal}
        type="button"
      >
        <Svg
          className="w-5 text-text"
          src="/svgs/close.svg#close"
          title="Close"
          viewBox="0 0 24 24"
        />
      </button>

      <div className="px-contained py-contained max-h-[calc(var(--viewport-height)-2rem)] overflow-y-auto scrollbar-hide">
        {modal.children}
      </div>
    </div>
  ) : null;
}

Modal.displayName = 'Modal';
